import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import Store from "../../index";
import { api } from "@/lib";
import { getModule } from "vuex-module-decorators";
import { AccountModule } from "@/store/modules";

const accountModule = getModule(AccountModule);

const name = "metrics";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true })
export default class MetricsModule extends VuexModule {
  isLoading: boolean = false;
  types: Array<any> = [];

  @Mutation
  setLoading(payload) {
    this.isLoading = payload;
  }

  @Mutation
  setTypes(payload) {
    this.types = payload;
  }

  @Action
  async getAll() {
    let url = `/metrics`;
    const response = await api.getAsync(url);
    return response;
  }

  @Action
  async getByFacilityAndType() {
    let facilities = accountModule.homeFacilitiesUserSettings;

    const facility = facilities && facilities[0] ? `?FacilityCodes=${facilities}&` : "?";
    const types = this.types ? `Type=${this.types}` : "";
    const url = `/metrics` + facility + types;
    const response = await api.getAsync(url.trim());
    return response;
  }
}
